<template>
  <page-article class="campus_recruiting_content_area page_article_block">
    <portlet>
      <div class="col-12">
        <enterprise-edit-recruitment-orientation @slots:changed="updateRecruitmentOrientations" />
      </div>
      <div class="col-12">
        <button-wrapper
          class="text-center"
          @click.prevent="submitRecruitmentOrientations"
        >
          更新
        </button-wrapper>
      </div>
    </portlet>
  </page-article>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import pageArticle from '~components/pages/Article'
import Portlet from '~components/common/Portlet'
import ButtonWrapper from '~components/common/buttons'
import EnterpriseEditRecruitmentOrientation from '../common/EnterpriseEditRecruitmentOrientation'
export default {
  name: 'EnterpriseRecruitmentOrientationDetailsContent',
  components: {
    pageArticle,
    Portlet,
    ButtonWrapper,
    EnterpriseEditRecruitmentOrientation
  },
  data () {
    return {
      orientations: []
    }
  },
  computed: {
    ...mapGetters('pages/campus-recruiting', [
      'currentRecruitmentGetter'
    ])
  },
  methods: {
    ...mapActions('pages/enterprises', [
      'modifyOrderById'
    ]),
    updateRecruitmentOrientations (orientations) {
      this.orientations = orientations
    },
    async submitRecruitmentOrientations () {
      await this.modifyOrderById({
        campus_recruitment_id: this.currentRecruitmentGetter.recruitment_id,
        recruitmentOrientations: this.orientations
      })
      this.$router.push({
        path: `/campus-recruiting/${this.$route.params.id}/enterprise`,
        query: {
          segment: '報名紀錄'
        }
      })
    }
  }
}
</script>
